import AppDialog from "./Dialog";

export default AppDialog;
